import images from "./images";

const portfolio = [
    {
        id: 1,
        image: images.portfolio1,
        title: "Lockout Assistance",
        details: {
            date: "May 5, 2024",
            client: "Downtown Residential Complex",
            category: "Emergency Services",
            duration: "Immediate Response",
            location: "Central City District",
            cost: "Flat Emergency Rate + Parts (if needed)",
            leadLocksmith: "Michael Turner"
        },
        paragraphs: [
            "Responding swiftly to a late-night residential lockout, our team provided immediate assistance to a client locked out of their apartment. The priority was to ensure safety and non-destructive entry wherever possible.",
            "With specialized tools and years of field experience, the technician successfully gained entry within minutes, ensuring no damage to the lock or door, and reassured the client with professional, empathetic service."
        ],
        gallery: [
            images.portfolio1Gallery1,
            images.portfolio1Gallery2,
            images.portfolio1Gallery3,
            images.portfolio1Gallery4,
            images.portfolio1Gallery5,
            images.portfolio1Gallery6,
        ],
        challenges: [
            "Reaching the Location Quickly During Peak Traffic",
            "Ensuring Non-Destructive Entry in a High-Security Door",
            "Calming an Anxious Client During a Stressful Situation"
        ],
        solutions: [
            "Optimized Dispatch and GPS Routing",
            "Use of Professional Lock-Picking Tools and Techniques",
            "Clear Communication and On-Site Reassurance"
        ],
        results: [
            "Successful Lockout Resolution in Under 20 Minutes",
            "No Damage to Door or Lock Mechanism",
            "High Client Satisfaction and Repeat Service Request"
        ]
    },
    {
        id: 2,
        image: images.portfolio2,
        title: "Smart Lock",
        details: {
            date: "June 2, 2024",
            client: "Greenfield Modern Residences",
            category: "Lock Installation",
            duration: "Half Day",
            location: "Greenfield Suburb, NY",
            cost: "Based on Lock Model and Door Type",
            leadLocksmith: "Alicia Ramirez"
        },
        paragraphs: [
            "The Smart Lock Installation project involved upgrading traditional deadbolts to modern, keyless smart locks across multiple residential units. The goal was to improve convenience, remote access, and overall security for homeowners.",
            "Our locksmith team ensured seamless integration with mobile apps, Wi-Fi connectivity, and biometric features where applicable. Homeowners were also guided through setup and trained on usage for maximum ease and safety."
        ],
        gallery: [
            images.portfolio2Gallery1,
            images.portfolio2Gallery2,
            images.portfolio2Gallery3,
            images.portfolio2Gallery4,
            images.portfolio2Gallery5,
            images.portfolio2Gallery6,
        ],
        challenges: [
            "Adapting Smart Locks to Varying Door Types",
            "Ensuring Wi-Fi Compatibility in Each Unit",
            "Training Non-Tech-Savvy Residents"
        ],
        solutions: [
            "Careful Door Frame Assessment and Adjustment",
            "Pre-Installation Wi-Fi Signal Testing",
            "Step-by-Step On-Site Demonstrations and Support Materials"
        ],
        results: [
            "Smooth Installation Across All Units",
            "Improved Home Access and Control for Residents",
            "Positive Feedback on Technology Integration and Support"
        ]
    },
    {
        id: 3,
        image: images.portfolio3,
        title: "Lock Repair",
        details: {
            date: "May 14, 2024",
            client: "Downtown Business Center",
            category: "Emergency Services",
            duration: "2 Hours",
            location: "Central Business District, LA",
            cost: "Hourly Rate + Parts Replaced",
            leadLocksmith: "Marcus Trent"
        },
        paragraphs: [
            "Our team was called in for an emergency lock repair after a malfunctioning door lock disrupted access to a secured office space. The issue needed urgent attention to restore functionality and ensure security.",
            "The repair involved disassembling the faulty mechanism, replacing damaged tumblers, and realigning internal components. A thorough post-repair check ensured smooth operation and reinforced door security."
        ],
        gallery: [
            images.portfolio3Gallery1,
            images.portfolio3Gallery2,
            images.portfolio3Gallery3,
            images.portfolio3Gallery4,
            images.portfolio3Gallery5,
            images.portfolio3Gallery6,
        ],
        challenges: [
            "Responding Rapidly During Business Hours",
            "Avoiding Further Damage to the Lock Assembly",
            "Maintaining Security During the Repair Process"
        ],
        solutions: [
            "Dispatch Within 30 Minutes of Call",
            "Precision Repair Using Advanced Diagnostic Tools",
            "Temporary Access Restriction Measures During Repair"
        ],
        results: [
            "Restored Lock Functionality in Under 2 Hours",
            "Minimized Business Downtime",
            "Client Retained Emergency Support Contract for Future Needs"
        ]
    },
    {
        id: 4,
        image: images.portfolio4,
        title: "CCTV Installation",
        details: {
            date: "June 5, 2024",
            client: "Maple Heights Residences",
            category: "Security Solutions",
            duration: "3 Days",
            location: "Maple Heights, TX",
            cost: "Project-Based Pricing Depending on Camera Quantity",
            leadLocksmith: "Elena Cruz"
        },
        paragraphs: [
            "As part of a broader residential security upgrade, our team implemented a comprehensive CCTV surveillance system across multiple entry points, common areas, and parking zones within the Maple Heights community.",
            "We focused on delivering seamless camera integration, remote monitoring capabilities, and night vision functionality using high-definition IP cameras for reliable and real-time video coverage."
        ],
        gallery: [
            images.portfolio4Gallery1,
            images.portfolio4Gallery2,
            images.portfolio4Gallery3,
            images.portfolio4Gallery4,
            images.portfolio4Gallery5,
            images.portfolio4Gallery6,
        ],
        challenges: [
            "Minimizing Disruption to Residents During Installation",
            "Covering All Blind Spots with Minimal Equipment",
            "Ensuring Compatibility with Existing Security Systems"
        ],
        solutions: [
            "Planned Installation Schedule with Resident Notification",
            "Strategic Camera Placement with Wide-Angle Coverage",
            "System Integration with Existing Access Controls"
        ],
        results: [
            "Enhanced Security and Surveillance for All Residents",
            "Increased Resident Confidence and Safety",
            "Positive Feedback and Referral for Additional Projects"
        ]
    },
    {
        id: 5,
        image: images.portfolio5,
        title: "Electronic Locks",
        details: {
            date: "May 12, 2024",
            client: "TechSecure Offices",
            category: "Lock Installation",
            duration: "2 Days",
            location: "Silicon Valley, CA",
            cost: "Flat Rate Per Door with Optional Features",
            leadLocksmith: "Jordan Blake"
        },
        paragraphs: [
            "Our Electronic Lock installation project for TechSecure Offices introduced modern access control with enhanced digital security features. The goal was to streamline office entry while maintaining high-level protection.",
            "We installed keypad-enabled and Bluetooth-controlled locks on office doors, integrated with their existing security management system to allow remote access permissions and tracking."
        ],
        gallery: [
            images.portfolio5Gallery1,
            images.portfolio5Gallery2,
            images.portfolio5Gallery3,
            images.portfolio5Gallery4,
            images.portfolio5Gallery5,
            images.portfolio5Gallery6,
        ],
        challenges: [
            "Integrating New Locks with Legacy Security Systems",
            "Ensuring All Employees Were Trained on Digital Access",
            "Minimizing Downtime During Business Hours"
        ],
        solutions: [
            "Conducted Compatibility Tests Before Installation",
            "Provided Onsite Staff Training and User Manuals",
            "Scheduled After-Hours Installations to Avoid Disruption"
        ],
        results: [
            "Fully Digital Lock System Operational in 2 Days",
            "Improved Access Management and Audit Capability",
            "Client Plans Expansion of Electronic Locks to Branch Offices"
        ]
    },
    {
        id: 6,
        image: images.portfolio6,
        title: "Alarm System",
        details: {
            date: "May 30, 2024",
            client: "Greenwood Residences",
            category: "Security Solutions",
            duration: "3 Days",
            location: "Portland, OR",
            cost: "Package-Based Pricing Depending on Coverage",
            leadLocksmith: "Melissa Grant"
        },
        paragraphs: [
            "Our Alarm System installation project aimed to enhance home security for Greenwood Residences through the implementation of a smart, responsive intrusion detection system.",
            "We installed door and window sensors, motion detectors, and a centralized control panel with mobile alerts and emergency contact features. The system was integrated with their smart home network for seamless control."
        ],
        gallery: [
            images.portfolio6Gallery1,
            images.portfolio6Gallery2,
            images.portfolio6Gallery3,
            images.portfolio6Gallery4,
            images.portfolio6Gallery5,
            images.portfolio6Gallery6,
        ],
        challenges: [
            "Ensuring Full Coverage Without Excess Hardware",
            "Synchronizing With Existing Smart Home Devices",
            "Educating Homeowners on System Management"
        ],
        solutions: [
            "Conducted Site Audit to Optimize Sensor Placement",
            "Configured Seamless Integration with Smart Hubs",
            "Held In-Person Demonstration and Provided Guides"
        ],
        results: [
            "Completed Installation Within 3 Days",
            "Homeowners Reported Increased Peace of Mind",
            "Reduced False Alarms and Enhanced Emergency Readiness"
        ]
    }

];

export default portfolio;